import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

/**
 * Props for PortfolioStockClicked event.
 *
 * @property security_code - instrument code
 */
export interface PortfolioStockClickedProps extends EventProps {
    security_code: string
}

/**
 * @event portfolio_stock_clicked
 * @description Emitted when a stock in the portfolio list is clicked.
 */
export const PortfolioStockClickedAnalytics = createAnalyticsStatic<PortfolioStockClickedProps>(
    ANALYTICS_EVENTS.PORTFOLIO.PORTFOLIO_STOCK_CLICKED,
)

export default PortfolioStockClickedAnalytics
